<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page rb-consent-page">
    <header>
      <h1 class="rb-ob-title">{{ preparationTitle }}</h1>
    </header>
    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ preparationBody }}</p>
    </div>
    <div class="rb-ob-actions">
      <button
          class="rb-ob-submit"
          type="button"
          :disabled="!ready"
          @click="checkDevice"
      >
        {{ $t('intake.readyOkCta') }}
      </button>
      <button
          class="rb-ob-submit rb-ob-submit-secondary"
          type="button"
          @click="goHome"
      >
        {{ $t('intake.readyOkHome') }}
      </button>
      <p class="rb-ob-status" role="status">{{ status }}</p>
    </div>
  </div>
</template>
<script>
import {clientError} from '@/intake/clientMessages'
import {resolveSessionPreparation, sessionPreparationReady} from '@/intake/sessionPreparation'

export default {
  name: 'MatchReadyOkStep',
  data() {
    return {care: null, session: null, legacy: false, loading: true, status: '', generation: 0, resolvedQueryKey: null}
  },
  computed: {
    ready() {
      return !this.loading && this.resolvedQueryKey === JSON.stringify(this.$route.query || {}) && sessionPreparationReady(this)
    },
    preparationTitle() {
      if (this.legacy) return this.$route.params.lang === 'en' ? 'Prepare for your appointment' : 'آماده‌سازی برای جلسه'
      return this.$t('intake.readyOkTitle')
    },
    preparationBody() {
      if (this.loading) return this.$t('intake.portal.loading')
      if (!this.ready) return this.$route.params.lang === 'en' ? 'Session preparation has not been confirmed.' : 'آمادگی جلسه هنوز تأیید نشده است.'
      if (!this.legacy) return this.$t('intake.readyOkBody')
      return this.$route.params.lang === 'en'
        ? 'This appointment continues your existing care. You can check your device; room access still depends on the appointment time and the server’s admission checks.'
        : 'این جلسه در ادامهٔ درمان قبلی تو ثبت شده است. می‌توانی دستگاهت را بررسی کنی؛ ورود به اتاق همچنان به زمان مجاز جلسه و بررسی دسترسی در سامانه بستگی دارد.'
    },
  },
  mounted() {
    return this.bootstrap()
  },
  watch: {'$route.query': {deep: true, handler() { return this.bootstrap() }}},
  beforeDestroy() { this.generation += 1 },
  methods: {
    async bootstrap() {
      const generation = ++this.generation
      const query = {...(this.$route.query || {})}
      const queryKey = JSON.stringify(query)
      const current = () => generation === this.generation && queryKey === JSON.stringify(this.$route.query || {})
      this.loading = true; this.care = null; this.session = null; this.legacy = false; this.status = ''; this.resolvedQueryKey = null
      try {
        const context = await resolveSessionPreparation(query)
        if (!current()) return
        this.care = context.care; this.session = context.session; this.legacy = context.legacy
        this.resolvedQueryKey = queryKey
        if (!sessionPreparationReady(context)) {
          this.$router.replace({
            name: 'intakeReadyLock', params: {lang: this.$route.params.lang || 'fa'},
            query: context.session ? {id: String(context.session.id)} : {},
          })
        }
      } catch (error) {
        if (current()) this.status = clientError(error, this.$route.params.lang || 'fa')
      } finally {
        if (current()) this.loading = false
      }
    },
    checkDevice() {
      if (!this.ready || !this.session) return
      this.$router.push({
        name: 'intakeSessionAvCheck',
        params: {lang: this.$route.params.lang || 'fa'},
        query: {id: String(this.session.id)},
      })
    },
    goHome() {
      this.$router.push({
        name: 'intakeClientHome',
        params: {lang: this.$route.params.lang || 'fa'},
      })
    },
  },
}
</script>
